module.exports = __webpack_public_path__ + "static/lastgen-flood-1304214174256acd0644dd7e53d8d8fe.mp4";